var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "40px",
    viewBox: "0 0 34 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.677402,38.3913043 L5.75738057,38.3913043 C3.69082126,38.3913043 2,36.7086957 2,34.6521739 L2,4.73913043 C2,2.6826087 3.69082126,1 5.75738057,1 L28.677402,1 C30.7439614,1 32.4347826,2.6826087 32.4347826,4.73913043 L32.4347826,34.6521739 C32.4347826,36.7086957 30.7439614,38.3913043 28.677402,38.3913043 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#C7D7E2",
    x: 5,
    y: 6,
    width: 22.6086957,
    height: 6.08695652
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5949657,18.6086957 L6.14416476,18.6086957 C5.49580473,18.6086957 5,18.0434783 5,17.3043478 C5,16.5652174 5.49580473,16 6.14416476,16 L25.5949657,16 C26.2433257,16 26.7391304,16.5652174 26.7391304,17.3043478 C26.7391304,18.0434783 26.2433257,18.6086957 25.5949657,18.6086957 Z",
    id: "Shape",
    fill: "#C7D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5949657,24.6086957 L6.14416476,24.6086957 C5.49580473,24.6086957 5,24.0434783 5,23.3043478 C5,22.5652174 5.49580473,22 6.14416476,22 L25.5949657,22 C26.2433257,22 26.7391304,22.5652174 26.7391304,23.3043478 C26.7391304,24.0434783 26.2433257,24.6086957 25.5949657,24.6086957 Z",
    id: "Shape",
    fill: "#C7D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0501672,29.6086957 L6.12374582,29.6086957 C5.48695652,29.6086957 5,29.0434783 5,28.3043478 C5,27.5652174 5.48695652,27 6.12374582,27 L16.0501672,27 C16.6869565,27 17.173913,27.5652174 17.173913,28.3043478 C17.173913,29.0434783 16.6869565,29.6086957 16.0501672,29.6086957 Z",
    id: "Shape",
    fill: "#C7D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.105947,40 L4.93753123,40 C2.20289855,40 0,37.8113208 0,35.0943396 L0,4.90566038 C0,2.18867925 2.20289855,0 4.93753123,0 L28.105947,0 C30.8405797,0 33.0434783,2.18867925 33.0434783,4.90566038 L33.0434783,35.0943396 C33.0434783,37.8113208 30.8405797,40 28.105947,40 Z M4.93753123,2.26415094 C3.45627186,2.26415094 2.27886057,3.43396226 2.27886057,4.90566038 L2.27886057,35.0943396 C2.27886057,36.5660377 3.45627186,37.7358491 4.93753123,37.7358491 L28.105947,37.7358491 C29.5872064,37.7358491 30.7646177,36.5660377 30.7646177,35.0943396 L30.7646177,4.90566038 C30.7646177,3.43396226 29.5872064,2.26415094 28.105947,2.26415094 L4.93753123,2.26415094 Z",
    id: "Shape",
    fill: "#454B54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.2748eebc9387cfd116bb94d6bd2ee869.svg";
export { ForwardRef as ReactComponent };